module.exports = __webpack_public_path__ + "img/antes_despues_316.de9a4b46.png";